<nav mat-tab-nav-bar backgroundColor="primary" [tabPanel]="panel">
    <a mat-tab-link routerLink="/library/packages" [active]="(url$ | async) == '/library/packages'" i18n>Packages</a>
    <a mat-tab-link routerLink="/library/commodities" [active]="(url$ | async) == '/library/commodities'" i18n>Commodities</a>
</nav>
<mat-tab-nav-panel #panel>
    <router-outlet></router-outlet>
</mat-tab-nav-panel>

